import Vconsole from 'vconsole'
var time = 0
var timer = null
window.addEventListener('click', function (e) {
  handleClick(e)
}, { passive: false })

function handleClick (e) {
  clearTimeout(timer)
  if (e.pageX < 150 && e.pageY < 150) {
    time++
    if (time >= 10) {
      var vs = new Vconsole()
      console.log('出现vconsole1111', vs)
    }
  }
  timer = setTimeout(() => {
    time = 0
  }, 500)
}



// WEBPACK FOOTER //
// ./src/vconsole.js